/**
 * Skeleton Loader - Unified
 * Covers: Top Banner Slider, 4-Image Collection, USP Icon List
 */

(function () {

  // ============================================================
  // HELPER — generic skeleton remover
  // ============================================================
  function initSkeleton(el, skeletonClass) {
    var img   = el.querySelector('img');
    var video = el.querySelector('video');

    function removeSkeleton() {
      el.classList.remove(skeletonClass);

      // Restore inline styles set by CSS-override
      var picture = el.querySelector('picture');
      if (picture) { picture.style.position = ''; picture.style.opacity = ''; }
      if (img)     { img.style.position = '';     img.style.opacity = '';     }
      if (video)   { video.style.position = '';   video.style.opacity = '';   }
    }

    if (video) {
      if (video.readyState >= 3) {
        removeSkeleton();
      } else {
        video.addEventListener('loadeddata', removeSkeleton);
        setTimeout(removeSkeleton, 4000); // fallback
      }
    } else if (img) {
      if (img.complete && img.naturalHeight !== 0) {
        requestAnimationFrame(removeSkeleton); // eager-load fix: 1 frame wait
      } else {
        img.addEventListener('load',  removeSkeleton);
        img.addEventListener('error', removeSkeleton);
      }
    } else {
      // No media (customHTML block etc.) — remove immediately
      removeSkeleton();
    }
  }


  

  // ============================================================
  // 1. TOP BANNER SLIDER  (.banner-skeleton)
  // ============================================================
  document.querySelectorAll('.Index_top_banner_slider_allloop_mainboxs_new').forEach(function (slide) {
    initSkeleton(slide, 'banner-skeleton');
  });

  // ============================================================
  // 2. 4-IMAGE COLLECTION CARDS  (.skeleton)
  // ============================================================
  document.querySelectorAll('.Index_custom_collections_allloop_mainboxs_new.skeleton').forEach(function (card) {
    initSkeleton(card, 'skeleton');
  });
  // ============================================================


  // ============================================================
  // 3. USP ICON LIST  (.skeleton)
  // ============================================================
  document.querySelectorAll('.Index_icon_with_text_list_allloop_mainboxs_new.skeleton').forEach(function (card) {
    initSkeleton(card, 'skeleton');
  });

  // ============================================================
  // 4. SIDE BY SIDE BANNER  (.skeleton-banner-side)
  // ============================================================
  document.querySelectorAll('.Index_side_by_side_banner_innerloop_mainboxs_new.skeleton-banner-side').forEach(function (card) {
  initSkeleton(card, 'skeleton-banner-side');
  });

// ============================================================
// 5. ARRIVALS DETAILS — 4 slots  (The saree edit)
// ============================================================
document.querySelectorAll('.skeleton-arrivals').forEach(function (slot) {
  initSkeleton(slot, 'skeleton-arrivals');
});

// ============================================================
// 6. CUSTOM CATEGORY SLIDER  (.skeleton) (Curated Collections)
// ============================================================

document.querySelectorAll('.Index_custom_category_innerloop_mainboxs_new.skeleton').forEach(function (card) {
  initSkeleton(card, 'skeleton');
})

// ============================================================
// 7. MIDDLE BANNER  (.skeleton-middle-banner)
// ============================================================
document.querySelectorAll('.skeleton-middle-banner').forEach(function (banner) {
  initSkeleton(banner, 'skeleton-middle-banner');
});

// ============================================================
// 8. VISIT OUR STORE  (.skeleton-store)
// ============================================================
document.querySelectorAll('.storebox.skeleton-store').forEach(function (card) {
  var img   = card.querySelector('img');
  var video = card.querySelector('video');

  function removeSkeleton() {
    card.classList.remove('skeleton-store');
    if (img)   { img.style.opacity = '';   img.style.position = ''; }
    if (video) { video.style.opacity = ''; video.style.position = ''; }
    var picture = card.querySelector('picture');
    if (picture) { picture.style.opacity = ''; picture.style.position = ''; }
  }

  if (video) {
    if (video.readyState >= 3) {
      removeSkeleton();
    } else {
      video.addEventListener('loadeddata', removeSkeleton);
      setTimeout(removeSkeleton, 4000);
    }
  } else if (img) {
    if (img.complete && img.naturalHeight !== 0) {
      requestAnimationFrame(removeSkeleton);
    } else {
      img.addEventListener('load',  removeSkeleton);
      img.addEventListener('error', removeSkeleton);
    }
  } else {
    removeSkeleton();
  }
});
// ============================================================
// 9. ROUND COLUMN LIST  (.skeleton-round-col)
// ============================================================
// Alpine x-if se DOM baad mein render hota hai,
// toh MutationObserver use karo
(function () {
  function initRoundColSkeletons(root) {
    root.querySelectorAll('.Index_round_column_list_2_allloop_mainboxs_new.skeleton-round-col').forEach(function (card) {
      initSkeleton(card, 'skeleton-round-col');
    });
  }

  // Abhi jo already DOM mein hain
  initRoundColSkeletons(document);

  // Alpine x-if ke baad render hone wale elements ke liye
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('skeleton-round-col')) {
            initSkeleton(node, 'skeleton-round-col');
          } else {
            initRoundColSkeletons(node);
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

// ============================================================
// 12. FORM APP DETAIL BANNER  (.skeleton-form-banner)
// ============================================================
document.querySelectorAll('.skeleton-form-banner').forEach(function (banner) {
  initSkeleton(banner, 'skeleton-form-banner');
});


// ============================================================
// 13. COLLECTION VIDEO GRID  (.skeleton-video-card)
// ============================================================
(function() {
  var swiperContainer = document.querySelector('.collection-video-slider.swiper');
  if (!swiperContainer) return;

  var isCenterMode = swiperContainer.hasAttribute('slide-center-mode');

  function removeSkeleton(card) {
    card.classList.remove('skeleton-video-card');
    var iframe = card.querySelector('iframe');
    var img = card.querySelector('img');
    if (iframe) { 
      iframe.style.opacity = ''; 
      iframe.style.position = ''; 
    }
    if (img) { 
      img.style.opacity = ''; 
    }
  }

  function initSkeletonForCard(card) {
    var iframe = card.querySelector('iframe');
    var img = card.querySelector('img');

    // Center mode - image se skeleton remove
    if (isCenterMode && img) {
      if (img.complete && img.naturalHeight !== 0) {
        requestAnimationFrame(function() {
          removeSkeleton(card);
        });
      } else {
        img.addEventListener('load', function() {
          removeSkeleton(card);
        });
        img.addEventListener('error', function() {
          removeSkeleton(card);
        });
        setTimeout(function() {
          removeSkeleton(card);
        }, 3000);
      }
    } 
    // Normal mode - iframe se skeleton remove
    else if (iframe) {
      var iframeLoaded = false;

      // Iframe load event
      iframe.addEventListener('load', function() {
        if (!iframeLoaded) {
          iframeLoaded = true;
          setTimeout(function() {
            removeSkeleton(card);
          }, 500);
        }
      });

      // Intersection Observer - jab visible ho
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && !iframeLoaded) {
            setTimeout(function() {
              if (!iframeLoaded) {
                iframeLoaded = true;
                removeSkeleton(card);
              }
            }, 1000);
          }
        });
      }, { threshold: 0.1 });
      
      observer.observe(card);

      // Fallback timeout
      setTimeout(function() {
        if (!iframeLoaded) {
          iframeLoaded = true;
          removeSkeleton(card);
        }
      }, 4000);
    } else {
      // No iframe, no image - remove immediately
      removeSkeleton(card);
    }
  }

  // Initial cards ko process karo
  document.querySelectorAll('.product-video-card.skeleton-video-card').forEach(function(card) {
    initSkeletonForCard(card);
  });

  // Agar dynamically cards add hote hain (rare case)
  var cardObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.classList && node.classList.contains('skeleton-video-card')) {
          initSkeletonForCard(node);
        }
      });
    });
  });

  if (swiperContainer) {
    cardObserver.observe(swiperContainer, { childList: true, subtree: true });
  }
})();


// ============================================================
// 14. COLLECTION META COLUMNS  (.skeleton-meta-column)
// ============================================================
document.querySelectorAll('.Collection_meta_columns_loops_mainbox_new.skeleton-meta-column').forEach(function (card) {
  var img   = card.querySelector('img');
  var video = card.querySelector('video');

  function removeSkeleton() {
    card.classList.remove('skeleton-meta-column');
    if (img) { 
      img.style.opacity = ''; 
      img.style.position = ''; 
    }
    if (video) { 
      video.style.opacity = ''; 
      video.style.position = ''; 
    }
    var picture = card.querySelector('picture');
    if (picture) { 
      picture.style.opacity = ''; 
      picture.style.position = ''; 
    }
  }

  if (video) {
    if (video.readyState >= 3) {
      removeSkeleton();
    } else {
      video.addEventListener('loadeddata', removeSkeleton);
      setTimeout(removeSkeleton, 4000);
    }
  } else if (img) {
    if (img.complete && img.naturalHeight !== 0) {
      requestAnimationFrame(removeSkeleton);
    } else {
      img.addEventListener('load',  removeSkeleton);
      img.addEventListener('error', removeSkeleton);
    }
  } else {
    removeSkeleton();
  }
});

// ============================================================
// 15. Menu Image  (.skeleton-middle-banner)
// ============================================================
document.querySelectorAll('.skeleton-menu-image').forEach(function (banner) {
  initSkeleton(banner, 'skeleton-menu-image');
});



// ============================================================
// 18. COLLECTION COLUMNS SLIDER
// ============================================================
document.querySelectorAll('.Collection_meta_columns_loops_mainbox_new').forEach(function (card) {
  var img   = card.querySelector('img');
  var video = card.querySelector('video');

  // Add skeleton class initially
  card.classList.add('skeleton-collection-column');

  function removeSkeleton() {
    card.classList.remove('skeleton-collection-column');
    if (img) { 
      img.style.opacity = ''; 
      img.style.position = ''; 
    }
    if (video) { 
      video.style.opacity = ''; 
      video.style.position = ''; 
    }
    var picture = card.querySelector('picture');
    if (picture) { 
      picture.style.opacity = ''; 
      picture.style.position = ''; 
    }
  }

  if (video) {
    if (video.readyState >= 3) {
      removeSkeleton();
    } else {
      video.addEventListener('loadeddata', removeSkeleton);
      setTimeout(removeSkeleton, 4000);
    }
  } else if (img) {
    if (img.complete && img.naturalHeight !== 0) {
      requestAnimationFrame(removeSkeleton);
    } else {
      img.addEventListener('load',  removeSkeleton);
      img.addEventListener('error', removeSkeleton);
    }
  } else {
    removeSkeleton();
  }
});


// ============================================================
// 19. COLLECTION CATEGORY LISTS SLIDER
// ============================================================
document.querySelectorAll('.Collection_category_lists_innerloop_mainboxs_new.skeleton-category-item').forEach(function (card) {
  var img   = card.querySelector('img');
  var video = card.querySelector('video');

  function removeSkeleton() {
    card.classList.remove('skeleton-category-item');
    if (img) { 
      img.style.opacity = ''; 
      img.style.position = ''; 
    }
    if (video) { 
      video.style.opacity = ''; 
      video.style.position = ''; 
    }
    var picture = card.querySelector('picture');
    if (picture) { 
      picture.style.opacity = ''; 
      picture.style.position = ''; 
    }
    // Restore title text
    var title = card.querySelector('.Collection_category_lists_innerloop_innerboxs_2_titletextboth_new h3');
    if (title) {
      title.style.color = '';
      title.style.background = '';
    }
  }

  if (video) {
    if (video.readyState >= 3) {
      removeSkeleton();
    } else {
      video.addEventListener('loadeddata', removeSkeleton);
      setTimeout(removeSkeleton, 4000);
    }
  } else if (img) {
    if (img.complete && img.naturalHeight !== 0) {
      requestAnimationFrame(removeSkeleton);
    } else {
      img.addEventListener('load',  removeSkeleton);
      img.addEventListener('error', removeSkeleton);
    }
  } else {
    // No image/video, just title - remove skeleton after brief delay
    setTimeout(removeSkeleton, 200);
  }
});


// ============================================================
// 20. COLLECTION SIDES BY SIDES
// ============================================================
document.querySelectorAll('.Collection_sides_by_sides_mainleft_new.skeleton-side-by-side, .Collection_sides_by_sides_mainright_new.skeleton-side-by-side').forEach(function(side) {
  var img = side.querySelector('img');
  var video = side.querySelector('video');

  function removeSkeleton() {
    side.classList.remove('skeleton-side-by-side');
    if (img) { img.style.opacity = ''; img.style.position = ''; }
    if (video) { video.style.opacity = ''; video.style.position = ''; }
    var picture = side.querySelector('picture');
    if (picture) { picture.style.opacity = ''; picture.style.position = ''; }
  }

  if (video) {
    if (video.readyState >= 3) {
      removeSkeleton();
    } else {
      video.addEventListener('loadeddata', removeSkeleton);
      setTimeout(removeSkeleton, 4000);
    }
  } else if (img) {
    if (img.complete && img.naturalHeight !== 0) {
      requestAnimationFrame(removeSkeleton);
    } else {
      img.addEventListener('load', removeSkeleton);
      img.addEventListener('error', removeSkeleton);
    }
  } else {
    removeSkeleton();
  }
});


// ============================================================
// 21. COLLECTION META BANNER (Desktop + Mobile)
// ============================================================
document.querySelectorAll('.Collection_meta_banner_main_new.skeleton-meta-banner').forEach(function(banner) {
  var img = banner.querySelector('img');
  var video = banner.querySelector('video');

  function removeSkeleton() {
    banner.classList.remove('skeleton-meta-banner');
    if (img) { 
      img.style.opacity = ''; 
      img.style.position = ''; 
    }
    if (video) { 
      video.style.opacity = ''; 
      video.style.position = ''; 
    }
    var picture = banner.querySelector('picture');
    if (picture) { 
      picture.style.opacity = ''; 
      picture.style.position = ''; 
    }
  }

  if (video) {
    if (video.readyState >= 3) {
      removeSkeleton();
    } else {
      video.addEventListener('loadeddata', removeSkeleton);
      setTimeout(removeSkeleton, 4000);
    }
  } else if (img) {
    if (img.complete && img.naturalHeight !== 0) {
      requestAnimationFrame(removeSkeleton);
    } else {
      img.addEventListener('load', removeSkeleton);
      img.addEventListener('error', removeSkeleton);
    }
  } else {
    removeSkeleton();
  }
});



// ============================================================
// 22. INDEX CUSTOM CATEGORY SLIDER (Womens Occassion)
// ============================================================
document.querySelectorAll('.Index_custom_category_innerloop_mainboxs_new.skeleton-custom-category').forEach(function(card) {
  var img = card.querySelector('img');
  var video = card.querySelector('video');

  function removeSkeleton() {
    card.classList.remove('skeleton-custom-category');
    if (img) { 
      img.style.opacity = ''; 
      img.style.position = ''; 
    }
    if (video) { 
      video.style.opacity = ''; 
      video.style.position = ''; 
    }
    var picture = card.querySelector('picture');
    if (picture) { 
      picture.style.opacity = ''; 
      picture.style.position = ''; 
    }
  }

  if (video) {
    if (video.readyState >= 3) {
      removeSkeleton();
    } else {
      video.addEventListener('loadeddata', removeSkeleton);
      setTimeout(removeSkeleton, 4000);
    }
  } else if (img) {
    if (img.complete && img.naturalHeight !== 0) {
      requestAnimationFrame(removeSkeleton);
    } else {
      img.addEventListener('load', removeSkeleton);
      img.addEventListener('error', removeSkeleton);
    }
  } else {
    removeSkeleton();
  }
});

// ============================================================
// 23. raja kumari 3 video
// ============================================================
document.querySelectorAll('.rajakumari3video_allloop_mainboxs_new.skeleton').forEach(function (card) {
    initSkeleton(card, 'skeleton');
  });


// ============================================================
// 23. bridal page
// ============================================================
document.querySelectorAll('.taptoplay_allloop_mainboxs_new.skeleton').forEach(function (card) {
    initSkeleton(card, 'skeleton');
  });





})();